module.exports = __webpack_public_path__ + "img/faq-01-494x823.6b0aa2a3.png";